module.exports = __webpack_public_path__ + "assets/img/icon9.5368b513.svg";